import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { modelClass } from '/imports/api/sellTargets';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { PageHeading } from '/imports/ui/PageHeading';
import { Button } from '/imports/ui/Button';
import { Icon } from '/imports/ui/Icon';
import { strings } from '/imports/strings';
import { SellTargetsBulkModal } from '/imports/ui/SellTargetsBulkModal';
import { useUser } from '/imports/hooks';

const SellTargetsHeader = () => {
  const { pathPrefix, pluralName, icon } = modelClass;
  const [bulkOpen, setBulkOpen] = useState(false);
  return (
    <>
      <PageHeading
        left={<h1>{icon && <Icon icon={icon} /> || null}{pluralName}</h1>}
        right={
          <div>
            <Button className="btn secondary" onClick={() => setBulkOpen(true)}>Bulk</Button>
            <Link to={`${pathPrefix}/new`}>
              <Button className="btn primary">{strings.New()}</Button>
            </Link>
          </div>
        }
      />
      {bulkOpen && <SellTargetsBulkModal onClose={() => setBulkOpen(false)} />}
    </>
  );
};

export const SellTargetsPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    header={<SellTargetsHeader />}
    columns={[{ field: 'cardId', label: 'Card ID' }, { field: 'card', label: 'Card' }, { field: 'sellcap', label: 'Sell Cap' }, { field: 'minprice', label: 'Min Price' }]}
  />
);

void useUser;
